<div class="content flex-column text-black">
  <p *ngIf="!isDownloadInProgress">{{ data.download }}</p>
  <p *ngIf="isDownloadInProgress">Please wait until PDF is generated.</p>

  <div class="report-download-container d-flex flex-column">
    <ng-container *ngIf="isLoading; else reportContent">
      <div class="loading-state">
        <en-loader size="lg">Loading reports...</en-loader>
      </div>
    </ng-container>

    <ng-template #reportContent>

    <form [formGroup]="availableReportsForm"
          class="d-flex flex-wrap w-100"
          *ngIf="!isDownloadInProgress">
      <div class="d-flex w-50" *ngFor="let report of availableReports">
        <div class="d-flex flex-column" *ngIf="report.downloadStatus$ | async as downloadStatus">
          <en-checkbox
            [attr.label]="updateOutputLabel(report.label)"
            [attr.checked]="availableReportsForm.get(report.reportType)?.value ? '' : null"
            [attr.disabled]="availableReportsForm.get(report.reportType)?.disabled ? '' : null"
            (change)="availableReportsForm.get(report.reportType)?.setValue($event.target.checked)">
          </en-checkbox>
          <div *ngIf="report.status === 'Add to Cart'">
            <i [ngClass]="{ 'available': report.isAvailable }"
               class="fa fa-shopping-cart"
               aria-hidden="true"></i>
            <span [ngClass]="{ 'available': report.isAvailable }"
                  class="add-to-cart"
                  (click)="addToCart(report)"> Add to Cart </span>
          </div>
        </div>
      </div>
    </form>

    <div class="downloading-reports d-flex w-100 flex-column" *ngIf="isDownloadInProgress">
      <div *ngFor="let report of downloadingReports$ | async"
           class="report-line-container d-flex justify-content-between align-items-center w-100">
        <span class="report-label">{{ updateOutputLabel(report.label) }}</span>
        <ng-container *ngIf="report.downloadStatus$ | async as downloadStatus">
          <en-loader *ngIf="downloadStatus === DownloadStatus.InProgress; else statusText">Loading...</en-loader>
          <ng-template #statusText>
            <en-badge [attr.kind]="STATUS_KIND[downloadStatus]" size="lg">
              {{ STATUS_TEXT[downloadStatus] }}
            </en-badge>
          </ng-template>
        </ng-container>
      </div>
    </div>
    </ng-template>
  </div>
</div>

<div slot="footer" class="d-flex">
  <div class="flex-spacer"></div>
  <en-btn
          size="sm"
          type="button"
          *ngIf="!isDownloadInProgress"
          [disabled]="(numberOfselectedReports$ | async) === 0"
          (click)="startDownload()">
    Proceed
  </en-btn>
  <en-btn size="sm" type="button"
          *ngIf="isDownloadInProgress"
          [disabled]="!(isDownloadFinished$ | async)"
          (click)="download()">
    {{ data.mainAction }}
  </en-btn>
</div>

